import type { BoxProps } from '@chakra-ui/react'
import { Box, FormControl, Grid, Stack } from '@chakra-ui/react'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import React from 'react'

import { FormLabel } from '../components/FormLabel'
import { Radio } from '../components/Radio'
import { RadioGroup } from '../components/RadioGroup'
import { Switch } from '../components/Switch'
import {
  ExtraInsuranceSmeItemIconsEnum,
  getExtraInsuranceSmeIcon,
} from '../utils/getExtraInsuranceSmeIcon'

const ExtraInsuranceItem = ({
  children,
  label,
  tooltip,
  icon,
  sx,
}: {
  children: React.ReactNode
  label: string
  tooltip?: string
  icon: ExtraInsuranceSmeItemIconsEnum | false
  sx?: BoxProps['sx']
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, ...sx }}>
      {icon && getExtraInsuranceSmeIcon(icon, '48px', 'secondary.500')}
      <FormControl sx={{}}>
        <FormLabel tooltip={tooltip}>{label}</FormLabel>
        {children}
      </FormControl>
    </Box>
  )
}

export const ExtraInsuranceSme = ({ showIcons = true }: { showIcons?: boolean }) => {
  const { control, register, watch } = useFormContext()
  const flood = watch('flood')

  return (
    <Box sx={{ w: '100%', display: 'grid', gap: 4 }}>
      <Box
        sx={{
          w: '100%',
          display: 'grid',
          gridTemplateColumns: { base: '1fr', lg: '1fr 1fr 1fr' },
          gap: 8,
          placeItems: 'start',
        }}
      >
        <Grid sx={{ gap: 8 }}>
          <ExtraInsuranceItem
            label="Povodeň, záplava"
            tooltip="Povodeň, záplava"
            icon={showIcons && ExtraInsuranceSmeItemIconsEnum.Flood}
          >
            <Switch {...register('flood')} />
          </ExtraInsuranceItem>

          {flood && (
            <RadioGroup control={control} name="floodFrequency">
              <Stack direction="row" spacing={4}>
                <Radio value="never">Nikdy</Radio>
                <Radio value="once">Jednou</Radio>
                <Radio value="multiple">Vícekrát</Radio>
              </Stack>
            </RadioGroup>
          )}
        </Grid>
      </Box>
    </Box>
  )
}
